import React, { Component } from "react";
import { connect } from "react-redux";
import { MedBoxPicker } from "../../../../PickerOrder/PickerOrderPage/PickerOrderPage.styled";
import Viewer from "react-viewer";
import { MdOutlineImageSearch } from "react-icons/md";
import { message } from "antd";

let slideIndex = 0;

export class PickerMedBox extends Component {
  state = {
    visible: false,
  };

  medView = () => {
    if (this.props.selectedMed?.medImages?.length > 0) {
      this.setState({
        visible: true,
      });
    } else {
      message.info(`No images found for ${this.props.selectedMed?.skuName} `);
    }
  };

  render() {
    let { selectedMed } = this.props;
    let { visible } = this.state;
    return (
      <MedBoxPicker>
        <div className="medName">
          {selectedMed?.skuName}

          <span
            onClick={() => {
              this.medView();
            }}
          >
            <MdOutlineImageSearch />
          </span>
        </div>
        <p className="title">QTY</p>
        <p className="title">{selectedMed?.quantity}</p>
        {selectedMed?.reasonName ? (
          <div className="issueReason">{selectedMed?.reasonName}</div>
        ) : (
          ""
        )}

        <Viewer
          className="viewer-section"
          visible={visible}
          noClose={false}
          onClose={() => {
            this.setState({ visible: false });
          }}
          images={selectedMed?.medImages}
          container={null}
          activeIndex={slideIndex}
          defaultScale={1.2}
          minScale="1"
          maxScale="3"
          zoomSpeed="0.5"
          zIndex="10000"
        />
      </MedBoxPicker>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PickerMedBox);
